export const ADMIN_ROUTES = {
  DASHBOARD: '/admin/dashboard',
  USERS: '/admin/users',
  CRM: '/admin/crm',

  ASSESSMENTS_DASHBOARD: '/assessments/dashboard',
  ASSESSMENTS: '/assessments/all',
  PARTNERS: '/assessments/partners',
  ANALYSTS: '/assessments/analysts',
  VIEW_ANALYST: '/assessments/analysts/:analystId',
  INVOICES: '/assessments/credits',
  WORDS: '/assessments/words',

  UNIVERSITY: '/university/dashboard',
  UNIVERSITY_STUDENTS: '/university/students',
  UNIVERSITY_COURSES: '/university/courses',
  UNIVERSITY_COURSES_VIEW: '/university/courses/:courseId',
  UNIVERSITY_COURSES_EDIT: '/university/courses/:courseId/edit',
  UNIVERSITY_COURSES_CREATE: '/university/courses/create',
  UNIVERSITY_COURSES_DELETE: '/university/courses/:courseId/delete',
  UNIVERSITY_COURSES_ENROLL: '/university/courses/:courseId/enroll',
  UNIVERSITY_COURSES_UNENROLL: '/university/courses/:courseId/unenroll',
  UNIVERSITY_COURSES_STUDENTS: '/university/courses/:courseId/students',
  // Content creation routes
  UNIVERSITY_COURSES_MODULE_CONTENT_SELECT: '/university/courses/:courseId/modules/:moduleId/content/select',
  UNIVERSITY_COURSES_MODULE_CONTENT_VIDEO_CREATE: '/university/courses/:courseId/modules/:moduleId/content/video/create',
  UNIVERSITY_COURSES_MODULE_CONTENT_VIDEO_EDIT: '/university/courses/:courseId/modules/:moduleId/content/video/:contentId/edit',
  UNIVERSITY_COURSES_MODULE_CONTENT_DOCUMENT_CREATE: '/university/courses/:courseId/modules/:moduleId/content/document/create',
  UNIVERSITY_COURSES_MODULE_CONTENT_DOCUMENT_EDIT: '/university/courses/:courseId/modules/:moduleId/content/document/:contentId/edit',
  UNIVERSITY_COURSES_MODULE_CONTENT_QUIZ_CREATE: '/university/courses/:courseId/modules/:moduleId/content/quiz/create',
  UNIVERSITY_COURSES_MODULE_CONTENT_QUIZ_EDIT: '/university/courses/:courseId/modules/:moduleId/content/quiz/:contentId/edit',
  // Content view route
  UNIVERSITY_COURSES_MODULE_CONTENT_VIEW: '/university/courses/:courseId/modules/:moduleId/content/:contentId',
  // Certificates
  UNIVERSITY_CERTIFICATES: '/university/certificates',
  // Fallback
  NOT_FOUND: '*',
} as const;